import { render, staticRenderFns } from "./TiktokData.vue?vue&type=template&id=14c6a09c&scoped=true"
import script from "./TiktokData.vue?vue&type=script&lang=js"
export * from "./TiktokData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c6a09c",
  null
  
)

export default component.exports